module.exports = __webpack_public_path__ + "static/media/L.82efd462.jpg";